import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, Pencil, Trash2 } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";

export default function AdminSpecialisations() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [name, setName] = useState("");

  const load = () => api.get("/admin/specialisations").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const save = async () => {
    try {
      if (editing) await api.put(`/admin/specialisations/${editing.id}`, { name, status: "active" });
      else await api.post("/admin/specialisations", { name, status: "active" });
      toast.success("Saved"); setOpen(false); load();
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
  };
  const del = async (id) => { if (window.confirm("Delete specialisation?")) { await api.delete(`/admin/specialisations/${id}`); load(); } };

  return (
    <div>
      <div className="mb-4 flex items-center justify-between">
        <h1 className="font-heading text-2xl font-bold tracking-tight text-slate-900">Specialisations</h1>
        <Button className="bg-blue-800 hover:bg-blue-900" onClick={() => { setEditing(null); setName(""); setOpen(true); }} data-testid="add-spec-btn"><Plus className="mr-1.5 h-4 w-4" />Add Specialisation</Button>
      </div>
      <div className="flex flex-wrap gap-2 rounded-xl border border-slate-200 bg-white p-5">
        {items.map((s) => (
          <span key={s.id} className="group inline-flex items-center gap-1.5 rounded-full border border-slate-200 bg-slate-50 py-1 pl-3 pr-1.5 text-sm text-slate-700">
            {s.name}
            <button onClick={() => { setEditing(s); setName(s.name); setOpen(true); }} className="rounded-full p-1 hover:bg-slate-200"><Pencil className="h-3 w-3" /></button>
            <button onClick={() => del(s.id)} className="rounded-full p-1 hover:bg-red-100"><Trash2 className="h-3 w-3 text-red-500" /></button>
          </span>
        ))}
        {items.length === 0 && <p className="text-sm text-slate-400">No specialisations yet.</p>}
      </div>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent>
          <DialogHeader><DialogTitle>{editing ? "Edit" : "Add"} Specialisation</DialogTitle></DialogHeader>
          <div><Label>Name</Label><Input value={name} onChange={(e) => setName(e.target.value)} data-testid="spec-name" /></div>
          <DialogFooter><Button className="bg-blue-800 hover:bg-blue-900" onClick={save} data-testid="save-spec-btn">Save</Button></DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
